import { WATOMS_MODERN_COLORS } from "constants/constants";
import { roundNumber } from "../../../utils/roundNumber";
import orgsVideo from '../../../assets/wisdomNewOrgVideo.mp4';
import ismailiaVideo from '../../../assets/shobraVideo.mp4';
import { useEffect, useState } from "react";
import { API_BASE } from "config";
import person from "../../../assets/person.jpg";
import { fetchWisdomUserImage } from "services/wisdom/wisdomData";
import DashboardActiveOrganizations from "components/dashboard/DashboardActiveOrganizations";

// Square image that fits inside its container (min of container width & height)
const squareImageStyle = {
    width: "min(100cqw, 100cqh)",
    height: "min(100cqw, 100cqh)",
};

// Font size scales with the manager column's width
const managerNameStyle = {
    fontSize: "clamp(8px, 8cqw, 14px)",
};

const WisdomDashboardOrganizationOverview = ({ wisdomData, selectedOrg, generalInfo, selectedMonthIdx, handleSelectOrganization }) => {
    const [ACImageSrc, setACImageSrc] = useState(person);
    const [EXImageSrc, setEXImageSrc] = useState(person);

    useEffect(() => {
        const acUserId = generalInfo[selectedOrg?.id]?.managers?.[1]?.user_id;
        const exUserId = generalInfo[selectedOrg?.id]?.managers?.[0]?.user_id;

        const resolveImage = async (userId, setImageSrc) => {
            if (!userId) {
                setImageSrc(person);
                return;
            }

            const userImage = await fetchWisdomUserImage(userId);

            if (userImage?.file_path) {
                const safePath = userImage.file_path.replace(/\\/g, "/");
                const fileName = safePath.split("/").pop();
                setImageSrc(`${API_BASE}/api/v1/files/open/${encodeURIComponent(fileName)}`);
            } else {
                setImageSrc(person);
            }
        };

        resolveImage(acUserId, setACImageSrc);
        resolveImage(exUserId, setEXImageSrc);
    }, [selectedOrg, generalInfo]);

    return (
        selectedOrg?.id !== "All" ?
            <div className="md:h-[60%] flex flex-col rounded-2xl bg-[#2d3347] overflow-hidden">

                {/* Org's Manager info */}
                <div className="h-2/5 shrink-0 flex py-2 justify-evenly items-center">

                    <div className="px-2 w-1/4 h-full flex flex-col items-center gap-1" style={{ containerType: "inline-size" }}>
                        <div className="w-full flex-1 min-h-0 flex justify-center items-center" style={{ containerType: "size" }}>
                            <img
                                src={EXImageSrc}
                                className="object-cover rounded-2xl"
                                style={squareImageStyle}
                                alt="default manager photo"
                            />
                        </div>

                        <div
                            className="w-full shrink-0 text-white text-center leading-tight bg-gray-700 p-1"
                            style={managerNameStyle}
                            dir="rtl"
                        >
                            {generalInfo[selectedOrg?.id]?.managers[0]?.first_name}{" "}
                            {generalInfo[selectedOrg?.id]?.managers[0]?.middle_name}{" "}
                            {generalInfo[selectedOrg?.id]?.managers[0]?.last_name}
                        </div>
                    </div>

                    <div className="flex flex-col justify-center items-center gap-2 w-2/5">
                        <div className="bg-gray-700 text-white p-2 w-full text-center text-sm">
                            {selectedOrg?.name}
                        </div>
                    </div>

                    <div className="px-2 w-1/4 h-full flex flex-col items-center gap-1" style={{ containerType: "inline-size" }}>
                        <div className="w-full flex-1 min-h-0 flex justify-center items-center" style={{ containerType: "size" }}>
                            <img
                                src={ACImageSrc}
                                className="object-cover rounded-2xl"
                                style={squareImageStyle}
                                alt="default manager photo"
                            />
                        </div>

                        <div
                            className="w-full shrink-0 text-white text-center leading-tight bg-gray-700 p-1"
                            style={managerNameStyle}
                            dir="rtl"
                        >
                            {generalInfo[selectedOrg?.id]?.managers[1]?.first_name}{" "}
                            {generalInfo[selectedOrg?.id]?.managers[1]?.middle_name}{" "}
                            {generalInfo[selectedOrg?.id]?.managers[1]?.last_name}
                        </div>
                    </div>
                </div>

                {/* Org's video */}
                <div className="h-3/5 shrink-0">
                    {selectedOrg?.id === 15 ? (
                        <video
                            className="w-full h-full object-cover rounded-2xl"
                            src={ismailiaVideo}
                            autoPlay
                            muted
                            playsInline
                        />
                    ) : (
                        <video
                            className="w-full h-full object-cover rounded-2xl"
                            src={orgsVideo}
                            autoPlay
                            muted
                            playsInline
                        />
                    )}
                </div>
            </div> :
            <div className="md:h-[60%] md:max-h-[60%] min-h-[60%] flex flex-col justify-start gap-2">
                {/* Total Institutions */}
                <DashboardActiveOrganizations active={7} inActive={0} />
                {/* Organizations Total Scores */}
                <div className="relative h-3/4 bg-[#2d3347] rounded-2xl flex flex-col px-5 py-2 items-stretch overflow-hidden"
                    style={{
                        boxShadow: '0 2px 12px #0004',
                    }}
                >
                    {/* Title */}
                    <div className="relative text-[#facc15] text-center cursor-default"
                        style={{
                            fontWeight: 700,
                            fontSize: 15,
                            marginBottom: 18,
                            letterSpacing: 0.5,
                            zIndex: 1,
                            textShadow: '0 2px 8px #000a, 0 0 4px #222',
                            transition: 'color 0.2s ease, text-shadow 0.2s ease'
                        }}
                    >
                        الترتيب العام لوحدات المشروع
                    </div>
                    {/* Body */}
                    <div className="gap-3 flex flex-col justify-start overflow-x-hidden overflow-y-auto"
                        style={{
                            minHeight: 60,
                            maxHeight: 300,
                            zIndex: 1,
                            marginTop: 4,
                        }}
                    >
                        {Object.entries(wisdomData?.organizations || {})
                            .sort(([, a], [, b]) => {
                                if (selectedMonthIdx !== undefined) {
                                    // Safely get performance for this month (fallback to 0 if missing)
                                    const perfA = a.months?.[selectedMonthIdx]?.performance ?? 0;
                                    const perfB = b.months?.[selectedMonthIdx]?.performance ?? 0;
                                    return perfB - perfA; // high → low
                                } else {
                                    return b.overall - a.overall; // default sort
                                }
                            })
                            .map(([id, c]) => (
                                <div
                                    key={id}
                                    className="flex justify-between items-center hover:bg-gray-600 hover:bg-opacity-20 cursor-pointer"
                                    onClick={() => handleSelectOrganization(c.name)}
                                    style={{
                                        marginBottom: 0,
                                        transition: 'transform 0.2s ease, opacity 0.2s ease',
                                        borderRadius: 8,
                                        padding: '4px',
                                        minWidth: 0,                // ✅ allow children to shrink
                                        transformOrigin: 'center',  // ✅ scale from center
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'scale(1.02)';
                                        e.currentTarget.style.opacity = '0.9';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'scale(1)';
                                        e.currentTarget.style.opacity = '1';
                                    }}
                                >
                                    {/* Organization Name */}
                                    <div className="text-start text-[#fff] xl:text-base md:text-xs text-xs overflow-hidden"
                                        style={{
                                            minWidth: 115,
                                            maxWidth: 120,
                                            fontWeight: 900,
                                            marginRight: 8,
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            transition: 'color 0.2s ease'
                                        }}
                                        title={c.name}
                                    >
                                        {c.name}
                                    </div>
                                    {/* Bar Percentage */}
                                    <div className="relative flex-1 min-w-0 bg-[#444652] overflow-hidden"
                                        style={{
                                            height: 22,
                                            borderRadius: 18,
                                            boxShadow: '0 2px 8px #0002',
                                            marginLeft: 8,
                                            marginRight: 8,
                                            transition: 'box-shadow 0.2s ease',
                                        }}
                                    >
                                        {/* Bar fill */}
                                        <div
                                            style={{
                                                height: '100%',
                                                width: `${Math.min(100, Math.max(0, roundNumber(wisdomData?.organizations[id].months[selectedMonthIdx]?.performance || 0)))}%`,
                                                background: WATOMS_MODERN_COLORS[id % WATOMS_MODERN_COLORS.length],
                                                borderRadius: 18,
                                                transition: 'width 0.7s cubic-bezier(.4,2,.6,1)',
                                            }}
                                        />
                                    </div>
                                    {/* Percentage Number */}
                                    <div className="text-white text-left" style={{
                                        minWidth: 38,
                                        fontWeight: 900,
                                        fontSize: 17,
                                        marginLeft: 0,
                                        marginRight: 0,
                                        transition: 'color 0.2s ease'
                                    }}>
                                        {roundNumber(wisdomData?.organizations[id].months[selectedMonthIdx]?.performance || 0) !== undefined ? roundNumber(wisdomData?.organizations[id].months[selectedMonthIdx]?.performance || 0) : 0}%
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
            </div>
    )
};

export default WisdomDashboardOrganizationOverview;